module.exports = __webpack_public_path__ + "img/thumbnail_Alpaca_j_erythristic.89cd1e0d.png";